import { useRef, useEffect } from 'react';

export function useObjectRef(value) {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
